{{#if IsPartnerAd}}
<div class="col cad cad--partner">
	<div class="card border-0 ps-item align-items-center justify-content-center">
		<a class="stretched-link cad__lnk" href="{{LinkUrl}}?utm_content=category_link">
			<img class="card-img-top cad__img cad__img--bg" src={{ImageUrl}} alt="{{ImageAlternateText}}" />
			<img class="cad__img cad__img--text cad__img--bottom" src="{{TextUrl}}" alt="{{AlternateText}}" />
		</a>
	</div>
</div>
{{/if}}
{{#if IsLoyaltyAd }}
<div class="col cad cad--loyalty">
	<div class="card border-0 ps-item align-items-center justify-content-center">
		<a class="stretched-link cad__lnk" href="{{LinkUrl}}?utm_content=category_link">
			<img class="card-img-top cad__img cad__img--bg" src={{ImageUrl}} alt="{{ImageAlternateText}}" />
			<img class="cad__img cad__img--text cad__img--center" src="{{TextUrl}}" alt="{{AlternateText}}" />
		</a>
	</div>
</div>
{{else}}
<div class="col cad cad--mbu">
	<div class="card border-0 ps-item align-items-center justify-content-center">
		<a class="stretched-link cad__lnk" href="{{LinkUrl}}">
			<img class="card-img-top cad__img cad__img--bg" src={{ImageUrl}} alt="A dimmed image of one of our made by us costumes" />
			<img class="cad__img cad__img--text" src="/wwwroot/img/hc/us/category/ads/refresh/mbu-text.png" alt="{{AlternateText}}" />
		</a>
	</div>
</div>
{{/if}}